import { render, staticRenderFns } from "./BxiLogin.vue?vue&type=template&id=4bac4c3d"
import script from "./BxiLogin.vue?vue&type=script&lang=js"
export * from "./BxiLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports